import { FunctionComponent, ReactElement } from 'react';
import { ToolbarBaseProps } from '../ToolbarCollection';
import { ToolbarCollectionState } from '../../state';
import { ViewTypeState } from '../../state/ViewTypeState';

export interface CollectionToolbarActionsGroupProps {
  state: ToolbarCollectionState<any, any>;
  left?: ReactElement;
  viewsToolbarItem?: ReactElement;
  filtersElement?: ReactElement;
  MoreFiltersButton?: FunctionComponent | null;
  customColumns?: ReactElement | null;
  multiLevelSorting?: ReactElement;
  exportButton?: ReactElement;
  importButton?: ReactElement;
  search?: ToolbarBaseProps['search'];
  showCustomColumnsOnTheLeft?: boolean;
  hasTabs?: boolean;
  tableGridSwitchButton?: ReactElement;
  viewTypeState?: ViewTypeState;
}
